/**
 * Team Database - Comprehensive mappings for team name matching
 * Supports full names, abbreviations, nicknames, and cities
 */

// NFL Teams
export const NFL_TEAMS = {
  'arizona-cardinals': {
    full: 'Arizona Cardinals',
    city: 'Arizona',
    nickname: 'Cardinals',
    abbr: ['ARI', 'AZ'],
    variations: ['cardinals', 'arizona', 'ari', 'az']
  },
  'atlanta-falcons': {
    full: 'Atlanta Falcons',
    city: 'Atlanta',
    nickname: 'Falcons',
    abbr: ['ATL'],
    variations: ['falcons', 'atlanta', 'atl']
  },
  'baltimore-ravens': {
    full: 'Baltimore Ravens',
    city: 'Baltimore',
    nickname: 'Ravens',
    abbr: ['BAL'],
    variations: ['ravens', 'baltimore', 'bal']
  },
  'buffalo-bills': {
    full: 'Buffalo Bills',
    city: 'Buffalo',
    nickname: 'Bills',
    abbr: ['BUF'],
    variations: ['bills', 'buffalo', 'buf']
  },
  'carolina-panthers': {
    full: 'Carolina Panthers',
    city: 'Carolina',
    nickname: 'Panthers',
    abbr: ['CAR'],
    variations: ['panthers', 'carolina', 'car']
  },
  'chicago-bears': {
    full: 'Chicago Bears',
    city: 'Chicago',
    nickname: 'Bears',
    abbr: ['CHI'],
    variations: ['bears', 'chicago', 'chi']
  },
  'cincinnati-bengals': {
    full: 'Cincinnati Bengals',
    city: 'Cincinnati',
    nickname: 'Bengals',
    abbr: ['CIN'],
    variations: ['bengals', 'cincinnati', 'cin']
  },
  'cleveland-browns': {
    full: 'Cleveland Browns',
    city: 'Cleveland',
    nickname: 'Browns',
    abbr: ['CLE'],
    variations: ['browns', 'cleveland', 'cle']
  },
  'dallas-cowboys': {
    full: 'Dallas Cowboys',
    city: 'Dallas',
    nickname: 'Cowboys',
    abbr: ['DAL'],
    variations: ['cowboys', 'dallas', 'dal']
  },
  'denver-broncos': {
    full: 'Denver Broncos',
    city: 'Denver',
    nickname: 'Broncos',
    abbr: ['DEN'],
    variations: ['broncos', 'denver', 'den']
  },
  'detroit-lions': {
    full: 'Detroit Lions',
    city: 'Detroit',
    nickname: 'Lions',
    abbr: ['DET'],
    variations: ['lions', 'detroit', 'det']
  },
  'green-bay-packers': {
    full: 'Green Bay Packers',
    city: 'Green Bay',
    nickname: 'Packers',
    abbr: ['GB', 'GNB'],
    variations: ['packers', 'green bay', 'gb', 'gnb']
  },
  'houston-texans': {
    full: 'Houston Texans',
    city: 'Houston',
    nickname: 'Texans',
    abbr: ['HOU'],
    variations: ['texans', 'houston', 'hou']
  },
  'indianapolis-colts': {
    full: 'Indianapolis Colts',
    city: 'Indianapolis',
    nickname: 'Colts',
    abbr: ['IND'],
    variations: ['colts', 'indianapolis', 'ind', 'indy']
  },
  'jacksonville-jaguars': {
    full: 'Jacksonville Jaguars',
    city: 'Jacksonville',
    nickname: 'Jaguars',
    abbr: ['JAX', 'JAC'],
    variations: ['jaguars', 'jacksonville', 'jax', 'jac', 'jags']
  },
  'kansas-city-chiefs': {
    full: 'Kansas City Chiefs',
    city: 'Kansas City',
    nickname: 'Chiefs',
    abbr: ['KC', 'KAN'],
    variations: ['chiefs', 'kansas city', 'kc', 'kan']
  },
  'las-vegas-raiders': {
    full: 'Las Vegas Raiders',
    city: 'Las Vegas',
    nickname: 'Raiders',
    abbr: ['LV', 'LVR'],
    variations: ['raiders', 'las vegas', 'lv', 'lvr', 'vegas']
  },
  'los-angeles-chargers': {
    full: 'Los Angeles Chargers',
    city: 'Los Angeles',
    nickname: 'Chargers',
    abbr: ['LAC'],
    variations: ['chargers', 'los angeles', 'lac', 'la chargers']
  },
  'los-angeles-rams': {
    full: 'Los Angeles Rams',
    city: 'Los Angeles',
    nickname: 'Rams',
    abbr: ['LAR'],
    variations: ['rams', 'los angeles', 'lar', 'la rams']
  },
  'miami-dolphins': {
    full: 'Miami Dolphins',
    city: 'Miami',
    nickname: 'Dolphins',
    abbr: ['MIA'],
    variations: ['dolphins', 'miami', 'mia', 'phins']
  },
  'minnesota-vikings': {
    full: 'Minnesota Vikings',
    city: 'Minnesota',
    nickname: 'Vikings',
    abbr: ['MIN'],
    variations: ['vikings', 'minnesota', 'min', 'vikes']
  },
  'new-england-patriots': {
    full: 'New England Patriots',
    city: 'New England',
    nickname: 'Patriots',
    abbr: ['NE', 'NEP'],
    variations: ['patriots', 'new england', 'ne', 'nep', 'pats']
  },
  'new-orleans-saints': {
    full: 'New Orleans Saints',
    city: 'New Orleans',
    nickname: 'Saints',
    abbr: ['NO', 'NOR'],
    variations: ['saints', 'new orleans', 'no', 'nor']
  },
  'new-york-giants': {
    full: 'New York Giants',
    city: 'New York',
    nickname: 'Giants',
    abbr: ['NYG'],
    variations: ['giants', 'new york', 'nyg', 'ny giants']
  },
  'new-york-jets': {
    full: 'New York Jets',
    city: 'New York',
    nickname: 'Jets',
    abbr: ['NYJ'],
    variations: ['jets', 'new york', 'nyj', 'ny jets']
  },
  'philadelphia-eagles': {
    full: 'Philadelphia Eagles',
    city: 'Philadelphia',
    nickname: 'Eagles',
    abbr: ['PHI'],
    variations: ['eagles', 'philadelphia', 'phi', 'philly']
  },
  'pittsburgh-steelers': {
    full: 'Pittsburgh Steelers',
    city: 'Pittsburgh',
    nickname: 'Steelers',
    abbr: ['PIT'],
    variations: ['steelers', 'pittsburgh', 'pit']
  },
  'san-francisco-49ers': {
    full: 'San Francisco 49ers',
    city: 'San Francisco',
    nickname: '49ers',
    abbr: ['SF', 'SFO'],
    variations: ['49ers', 'san francisco', 'sf', 'sfo', 'niners', 'forty niners']
  },
  'seattle-seahawks': {
    full: 'Seattle Seahawks',
    city: 'Seattle',
    nickname: 'Seahawks',
    abbr: ['SEA'],
    variations: ['seahawks', 'seattle', 'sea', 'hawks']
  },
  'tampa-bay-buccaneers': {
    full: 'Tampa Bay Buccaneers',
    city: 'Tampa Bay',
    nickname: 'Buccaneers',
    abbr: ['TB', 'TAM'],
    variations: ['buccaneers', 'tampa bay', 'tb', 'tam', 'bucs', 'tampa']
  },
  'tennessee-titans': {
    full: 'Tennessee Titans',
    city: 'Tennessee',
    nickname: 'Titans',
    abbr: ['TEN'],
    variations: ['titans', 'tennessee', 'ten']
  },
  'washington-commanders': {
    full: 'Washington Commanders',
    city: 'Washington',
    nickname: 'Commanders',
    abbr: ['WAS', 'WSH'],
    variations: ['commanders', 'washington', 'was', 'wsh']
  }
};

/**
 * Find team by any variation (abbreviation, nickname, city, etc.)
 * @param {string} searchTerm - Search term (e.g., "PIT", "Steelers", "Pittsburgh")
 * @returns {Object|null} Team object or null if not found
 */
export function findNFLTeam(searchTerm) {
  if (!searchTerm) return null;

  const search = searchTerm.toLowerCase().trim();

  // Search through all teams
  for (const [key, team] of Object.entries(NFL_TEAMS)) {
    // Check full name
    if (team.full.toLowerCase() === search) {
      return { ...team, confidence: 100 };
    }

    // Check abbreviations
    if (team.abbr.some(abbr => abbr.toLowerCase() === search)) {
      return { ...team, confidence: 100 };
    }

    // Check nickname
    if (team.nickname.toLowerCase() === search) {
      return { ...team, confidence: 95 };
    }

    // Check city
    if (team.city.toLowerCase() === search) {
      return { ...team, confidence: 90 };
    }

    // Check variations
    if (team.variations.includes(search)) {
      return { ...team, confidence: 85 };
    }

    // Check if search term is contained in full name
    if (team.full.toLowerCase().includes(search) && search.length > 3) {
      return { ...team, confidence: 75 };
    }
  }

  return null;
}

/**
 * Match bet text to team
 * @param {string} betText - Bet text to parse
 * @returns {Object|null} Matched team with confidence
 */
export function matchTeamFromBetText(betText) {
  if (!betText) return null;

  const text = betText.toLowerCase();

  // Try to extract team name - look for common patterns
  // Pattern 1: Team name at start (e.g., "Eagles -5.5")
  const words = text.split(/\s+/);

  // Try first word
  let match = findNFLTeam(words[0]);
  if (match) return match;

  // Try first two words (e.g., "Kansas City")
  if (words.length > 1) {
    match = findNFLTeam(words.slice(0, 2).join(' '));
    if (match) return match;
  }

  // Try each word individually
  for (const word of words) {
    if (word.length < 2) continue; // Skip very short words
    match = findNFLTeam(word);
    if (match) return match;
  }

  return null;
}

/**
 * Get all team variations for a team
 * @param {string} teamName - Full team name from API
 * @returns {Array} All variations of the team name
 */
export function getTeamVariations(teamName) {
  const team = Object.values(NFL_TEAMS).find(t => t.full === teamName);
  if (!team) return [teamName];

  return [
    team.full,
    team.nickname,
    team.city,
    ...team.abbr,
    ...team.variations
  ];
}
